import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "projectIndex",
  class: "page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" From Blueprint to Execution: Your Operations Hub "),
    /*#__PURE__*/_createElementVNode("div", {
      class: "btn btn-outline-primary me-1 float-end",
      "data-bs-toggle": "modal",
      "data-bs-target": "#addProjectModal"
    }, " Add ")
  ])
], -1)
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Client"),
    /*#__PURE__*/_createElementVNode("th", null, "Project"),
    /*#__PURE__*/_createElementVNode("th", null, "Process / Module"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Updated At"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AddProjectModal = _resolveComponent("AddProjectModal")!
  const _component_UpdateProjectModal = _resolveComponent("UpdateProjectModal")!
  const _component_DeleteProjectModal = _resolveComponent("DeleteProjectModal")!
  const _component_DeleteProcessModal = _resolveComponent("DeleteProcessModal")!
  const _component_DeleteClientModal = _resolveComponent("DeleteClientModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DataTable, {
          class: "display table",
          data: _ctx.tableData,
          columns: _ctx.columns,
          ref: "table",
          options: _ctx.options
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["data", "columns", "options"])
      ]),
      _createVNode(_component_AddProjectModal, { onReload: _ctx.load }, null, 8, ["onReload"]),
      _createVNode(_component_UpdateProjectModal, {
        onReload: _ctx.load,
        projectId: _ctx.selectedProjectId
      }, null, 8, ["onReload", "projectId"]),
      _createVNode(_component_DeleteProjectModal, {
        onReload: _ctx.load,
        projectId: _ctx.selectedProjectId
      }, null, 8, ["onReload", "projectId"]),
      _createVNode(_component_DeleteProcessModal, {
        onReload: _ctx.load,
        projectId: _ctx.selectedProjectId,
        processId: _ctx.selectedProcessId,
        moduleId: _ctx.selectedModuleId
      }, null, 8, ["onReload", "projectId", "processId", "moduleId"]),
      _createVNode(_component_DeleteClientModal, {
        onReload: _ctx.load,
        clientId: _ctx.selectedClientId
      }, null, 8, ["onReload", "clientId"])
    ])
  ]))
}